import React, { useEffect, useState } from "react";
import "../../Restrictions/RestrictionsBanner/RestrictionsBanner.css";
import "../../Coporate-travel-management/CorporateBanner/CorporateBanner.css";
import BannerWrapper from "../../../commonComponents/BannerWrapper";
import Heading from "../../../utls/Heading";
import HeadingH1 from "../../../utls/HeadingH1";
const MIICESolutionBanner = ({ onLoad }) => {

  return (
    <>
      <BannerWrapper onLoad={onLoad}>
        {({ useHighRes, imageLoaded, handleImageLoad }) => (
          <div className="container-fluid ctm-banner position-relative" style={useHighRes && !imageLoaded ? { minHeight: 0 } : {}}>
            <div >
              <img
                src="https://blueberrywebsites.azureedge.net/BBT/New%20Banners%20all%20pages/New%20DesignBanners%20BBT/MICE%20Solutions.webp"
                alt="Contact Banner"
                className="w-100"
                // For high-speed, use eager loading; for low-speed, lazy loading.
                loading={useHighRes ? "eager" : "lazy"}
                // Attach the onLoad handler only for high-speed connections.
                onLoad={handleImageLoad}
                fetchpriority={useHighRes ? "high" : "auto"}
              />
              {imageLoaded ?
                <div className="ctm-text position-absolute text-white  mt-3">
                  <p className="fs4 text-uppercase busy grotesk-headings">GLOBAL TRAVEL</p>
                  <HeadingH1 className="banner-headings w-100">
                    Navigate Travel <br />
                    with Confidence
                  </HeadingH1>
                </div>
                :
                null
              }
            </div>
            {imageLoaded ?
              <div className="container why-staying px-md-5" >
                <div className="row">
                  <div className="col-md-12">
                    <Heading className="customheadings">
                      <span>About </span>Blueberry M.I.C.E.
                    </Heading>
                    <p className="mt-3">
                      At Blueberry Travel, we specialize in delivering world-class M.I.C.E. (Meetings, Incentives, Conferences, and Events) solutions tailored to businesses worldwide. Whether you’re hosting an exclusive seminar, an incentive retreat, or a large-scale international conference, our expert team ensures seamless planning, flawless execution, and an unforgettable experience for your attendees.
                    </p>
                    <p className="mt-3">
                      We provide end-to-end event management services, including travel arrangements, venue selection, logistics, and on-site coordination, making sure your event is both impactful and stress-free.
                    </p>
                  </div>
                </div>
              </div>
              :
              null
            }
          </div>
        )}
      </BannerWrapper >
    </>

  );
};

export default MIICESolutionBanner;
